import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../Student_New/UserApplications.scss";
import "../Student_New/Jobs.scss";
import PropagateLoader from "react-spinners/PropagateLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosArrowForward, IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import { MONTH_DETAILS } from "../data";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Grid, Tooltip, Typography } from "@mui/material";
import "./AdminDashboard.css";
import { LuClipboardEdit } from "react-icons/lu";
import { Spinner } from "react-bootstrap";
import { MdOutlineEdit, MdOutlineVerifiedUser } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { loginUserForAdminEmployee } from "../../actions/userActions";
import { RiDeleteBinLine } from "react-icons/ri";
import Popup from "reactjs-popup";
import PaginationWithLastButton from "../Student_New/PaginationWithLastButton";

function AdminEmployers() {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [employerData, setEmployerData] = useState("");
    const [sortByJobs, setSortByJobs] = useState(null);
    const [sortByActiveJobs, setSortByActiveJobs] = useState(null);
    const initialForm = {
        _id: "",
        name: "",
        phone: "",
        oldPhone: "",
        countryCode: "",
        oldCountryCode: "",
        city: "",
        organisationName: "",
        email: "",
        role: "Employer",
    };
    const initialBalance = {
        _id: "",
        connectCredit: "",
        connectSpent: "",
    };
    const [employee, setEmployee] = useState(initialForm);
    const [balanceConnect, setBalanceConnect] = useState(initialBalance);
    const [totalItem, setTotalItem] = useState(0);
    const [loading, setLoading] = useState(true);
    const [loading2, setLoading2] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginType, setLoginType] = useState("Employer");
    const [sortField, setSortField] = useState(null); // State for sorting field
    const [sortOrder, setSortOrder] = useState(null);
    const { isAuthenticated, user } = useSelector((state) => state.user);
    const borderRemoveRef = useRef(null);
    const [totalData, setTotalData] = useState(null);
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [currentSearchTerm, setCurrentSearchTerm] = useState("");
    const [totalpages, settotalpages] = useState(1);
    const modalRef = useRef(null);
    const handleLogin = async (userId) => {
        if (loginType === "Employer") {
            // Assuming loginUser is an action creator
            await dispatch(loginUserForAdminEmployee(userId, loginType));
            console.log("loginType", userId);
            localStorage.setItem("userType", loginType);
            localStorage.setItem("userLoggedIn", true);

            const userInfo = await axios.get("/api/user/me", {
                headers: {
                    "Content-Type": "application/json",
                    token: localStorage.getItem("token"),
                },
            });
            console.log(userInfo);
            const basicDetails = {
                name: userInfo?.data?.user?.name,
                email: userInfo?.data?.user?.email,
            };
            localStorage.setItem("basicDetails", JSON.stringify(basicDetails));
            navigate("/employerApplication/Internship");
        }
    };

    useEffect(() => {
        if (localStorage.getItem("token")) {
            if (user?.role === "User") {
                navigate("/");
            } else if (user?.role === "Employer") {
                navigate("/employerApplication/Internship");
            }
        }
    }, [isAuthenticated, user, navigate]);

    const getTotalData = async () => {
        try {
            const response = await axios.get("/api/user/getTotalUserAndJobs");
            setTotalData(response?.data);
            console.log(response?.data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        getTotalData();
    }, [employerData]);
    // const GetEmployerData = async (searchInput = "") => {
    //     setLoading(true);
    //     console.log(currentPage, "currentPage");
    //     try {
    //         const { data } = await axios.post("/api/user/getEmployerDataForAdmin", {
    //             searchInput,
    //             page: currentPage,
    //             pageSize:10, 
    //             sortBy: sortField, // Send all sort fields to the backend
    //             sortOrder: sortOrder, // Send all sort orders to the backend
    //         });
    //         setLoading(false);

    //         // Since the backend now handles the sorting and pagination for all fields,
    //         // we can directly use the data without additional processing
    //         setEmployerData(data.data);
    //         setTotalPages(data.totalPages);
    //         setTotalItem(data.totalItems);
    //     } catch (error) {
    //         setLoading(false);
    //         toast.error(error.response?.data || "An error occurred", {
    //             style: {
    //                 padding: "18px",
    //             },
    //         });
    //     }
    // };
    const GetEmployerData = async (searchInput = "") => {
        setLoading(true);
        console.log(currentPage, "currentPage");
        try {
            const { data } = await axios.post("/api/user/getEmployerDataForAdmin", {
                searchInput,
                page: searchInput ? 1 : currentPage, // Always start from page 1 when searching
                pageSize: 20,
                sortBy: sortField,
                sortOrder: sortOrder,
                // Add a flag to indicate if this is a search operation
                isSearch: searchInput ? true : false
            });
            setLoading(false);
            setEmployerData(data.data);
            setTotalPages(data.totalPages);
            setTotalItem(data.totalItems);

            // If this was a search operation, reset to page 1
            if (searchInput) {
                setCurrentPage(1);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data || "An error occurred", {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    const GetEmployerDataWithSort = async (searchInput = "", sortField = null, sortOrder = null, page = currentPage) => {
        setLoading(true);
        console.log("API call with explicit params:", { sortField, sortOrder, page });

        try {
            const { data } = await axios.post("/api/user/getEmployerDataForAdmin", {
                searchInput,
                page: page,
                pageSize: 20,
                sortBy: sortField,
                sortOrder: sortOrder,
            });

            setLoading(false);
            setEmployerData(data.data);
            setTotalPages(data.totalPages);
            setTotalItem(data.totalItems);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data || "An error occurred", {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    // Make sure your count functions are properly defined
    // const countJoblength = (jobs) => {
    //     return jobs ? jobs.filter((job) => job.opportunityType === "Job").length : 0;
    // };

    // const countInternshiplength = (jobs) => {
    //     return jobs ? jobs.filter((job) => job.opportunityType === "Internship").length : 0;
    // };

    // const countActiveJobs = (jobs) => {
    //     return jobs ? jobs.filter((job) => job.status === "Active").length : 0;
    // };

    // const countTotalHired = (jobs) => {
    //     if (!jobs) return 0;
    //     return jobs.reduce((total, job) => {
    //         const hiredCount = Array.isArray(job.userApplied) ? job.userApplied.filter((application) => application.status === "Hired").length : 0;
    //         return total + hiredCount;
    //     }, 0);
    // };

    // const countTotalApplied = (jobs) => {
    //     if (!jobs) return 0;
    //     return jobs.reduce((total, job) => {
    //         return total + (Array.isArray(job.userApplied) ? job.userApplied.length : 0);
    //     }, 0);
    // };

    // useEffect(() => {
    //     GetEmployerData();
    // }, [sortField, sortOrder]);

    // const handleSortnew = (field) => {
    //   if (sortField === field) {
    //     // If the same field is clicked again, toggle the sorting order
    //     setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    //   } else {
    //     // If a different field is clicked, set the new field and default sorting order to ascending
    //     setSortField(field);
    //     setSortOrder("asc");
    //   }
    // };
    const handleSortnew = (field, direction) => {
        setSortField(field);
        setSortOrder(direction);
    };
    console.log(sortField, sortOrder);

    // Updated handler function for sorting
    const handleSort = (field, order) => {

        console.log(field, order)
        setSortField(field);
        setSortOrder(order);
        // Reset to first page when sorting changes

        // For the job-related fields, we'll do frontend sorting
        if (["fixedPosted", "hourlyPosted", "activeFixedPosted", "totalFreelancersHired", "totalJobsApplied"].includes(field)) {
            const sortedData = [...employerData].sort((a, b) => {
                console.log("data", a, b)
                let valueA, valueB;

                if (field === "fixedPosted") {
                    valueA = countJoblength(a.jobs);
                    valueB = countJoblength(b.jobs);
                    console.log("values ", valueA, valueB)
                } else if (field === "hourlyPosted") {
                    valueA = countInternshiplength(a.jobs);
                    valueB = countInternshiplength(b.jobs);
                } else if (field === "activeFixedPosted") {
                    valueA = countActiveJobs(a.jobs);
                    valueB = countActiveJobs(b.jobs);
                } else if (field === "totalFreelancersHired") {
                    valueA = countTotalHired(a.jobs);
                    valueB = countTotalHired(b.jobs);
                } else if (field === "totalJobsApplied") {
                    valueA = countTotalApplied(a.jobs);
                    valueB = countTotalApplied(b.jobs);
                } else if (field === "companyName") {
                    valueA = a?.organisationName?.trim() || "";
                    valueB = b?.organisationName?.trim() || "";
                    if (order === "asc") {
                        if (valueA && !valueB) return -1;
                        if (!valueA && valueB) return 1;
                        return valueA.localeCompare(valueB);
                    } else {
                        if (valueA && !valueB) return 1;
                        if (!valueA && valueB) return -1;
                        return valueB.localeCompare(valueA);
                    }
                }
                return order === "asc" ? valueA - valueB : valueB - valueA;
            });

            setEmployerData(sortedData);
            return;
        }
        setCurrentPage(1);
        if (field === "profileStatus") {
            GetEmployerDataWithSort("", field, order, 1);
        } else {
            GetEmployerDataWithSort("", field, order, 1);
        }
    };

    // The count functions
    const countJoblength = (jobs) => {
        return jobs ? jobs.filter((job) => job.opportunityType === "Fixed Cost").length : 0;
    };

    const countInternshiplength = (jobs) => {
        return jobs ? jobs.filter((job) => job.opportunityType === "Hourly").length : 0;
    };

    const countActiveJobs = (jobs) => {
        return jobs ? jobs.filter((job) => job.status === "Approved").length : 0;
    };

    const countTotalHired = (jobs) => {
        if (!Array.isArray(jobs)) return 0;

        return jobs.reduce((total, currentJob) => {
            const currentJobId = String(currentJob?._id);

            const hiredCount =
                currentJob.userApplied?.reduce((sum, user) => {
                    const count =
                        user.appliedJobs?.filter((appliedJob) => {
                            const appliedJobJobId = String(appliedJob?.job?._id || appliedJob?.job);

                            return (
                                appliedJob?.status === "Hired" &&
                                appliedJobJobId === currentJobId
                            );
                        }).length || 0;

                    return sum + count;
                }, 0) || 0;

            return total + hiredCount;
        }, 0);
    };


    const countTotalApplied = (jobs) => {
        if (!jobs) return 0;
        return jobs.reduce((total, job) => {
            return total + (Array.isArray(job.userApplied) ? job.userApplied.length : 0);
        }, 0);
    };
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        if (sortField === "profileStatus") {
            // For profileStatus, use the specific function with current sort parameters
            GetEmployerDataWithSort(isSearchMode ? currentSearchTerm : "", sortField, sortOrder, currentPage);
        }
        else if (sortField === null || sortField !== "profileStatus") {
            // Pass the current search term if in search mode
            GetEmployerData(isSearchMode ? currentSearchTerm : "");
        }
        window.scrollTo(0, 0);
    }, [currentPage]);

    // }
    // const countActiveJobs = (jobs) => {
    //     let activeJobsCount = 0;
    //     if (jobs && jobs.length) {
    //         // Ensure jobs is defined and not empty
    //         jobs.forEach((job) => {
    //             if (job.status === "Approved") {
    //                 activeJobsCount++;
    //             }
    //         });
    //     }
    //     return activeJobsCount;
    // };
    // const countTotalHired = (jobs) => {
    //     if (!jobs || !Array.isArray(jobs)) {
    //         return 0;
    //     }

    //     return jobs.reduce((totalHired, job) => {
    //         if (job.userApplied && Array.isArray(job.userApplied)) {
    //             const hiredForThisJob = job.userApplied.reduce((jobHired, user) => {
    //                 if (user.appliedJobs && Array.isArray(user.appliedJobs)) {
    //                     const hiredApplications = user.appliedJobs.filter((application) => application.status === "Hired");
    //                     return jobHired + hiredApplications.length;
    //                 }
    //                 return jobHired;
    //             }, 0);

    //             return totalHired + hiredForThisJob;
    //         }
    //         return totalHired;
    //     }, 0);
    // };

    // const countTotalApplied = (jobs) => {
    //     if (!jobs || !Array.isArray(jobs)) {
    //         return 0;
    //     }

    //     return jobs.reduce((totalApplied, job) => {
    //         if (job.userApplied && Array.isArray(job.userApplied)) {
    //             const appliedForThisJob = job.userApplied.reduce((jobApplied, user) => {
    //                 if (user.appliedJobs && Array.isArray(user.appliedJobs)) {
    //                     return jobApplied + user.appliedJobs.length;
    //                 }
    //                 return jobApplied;
    //             }, 0);

    //             return totalApplied + appliedForThisJob;
    //         }
    //         return totalApplied;
    //     }, 0);
    // };

    // const countJoblength = (jobs) => {
    //     let joblength = 0;
    //     if (jobs && jobs.length) {
    //         jobs.forEach((job) => {
    //             if (job.opportunityType === "Hourly") {
    //                 joblength++;
    //             }
    //         });
    //     }
    //     return joblength;
    // };

    // const countInternshiplength = (jobs) => {
    //     let internshiplength = 0;
    //     if (jobs && jobs.length) {
    //         jobs.forEach((job) => {
    //             if (job.opportunityType === "Fixed Cost") {
    //                 internshiplength++;
    //             }
    //         });
    //     }
    //     return internshiplength;
    // };

    // ACTIVE DEACTIVE OPTION:

    const [id, setId] = useState("");
    const [userStatus, setUserStatus] = useState("");

    const idSelector = (_id) => {
        setId(_id);
    };

    const ActiveUser = async () => {
        window.scrollTo(0, 0);
        setLoading(true);
        try {
            const { data } = await axios.post("/api/user/activedeactive", {
                id: id,
                status: "active",
            });
            // GetEmployerData();
            const userIndex = employerData.findIndex((user) => user._id === id);
            // If the user is found, update the active field directly
            if (userIndex !== -1) {
                employerData[userIndex].active = true;
            }
            toast.success("User is active now");
            setLoading(false);
            // ADD THIS: Refresh the filtered data if profileStatus filter is active
            if (sortField === "profileStatus") {
                GetEmployerDataWithSort("", sortField, sortOrder, currentPage);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error(error.response.data, {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    const DeActiveUser = async () => {
        window.scrollTo(0, 0);
        setLoading(true);
        try {
            const { data } = await axios.post("/api/user/activedeactive", {
                id: id,
                status: "de-active",
            });
            // GetEmployerData();
            const userIndex = employerData.findIndex((user) => user._id === id);
            // If the user is found, update the active field directly
            if (userIndex !== -1) {
                employerData[userIndex].active = false;
            }
            toast.success("User is not active now");
            setLoading(false);
            // ADD THIS: Refresh the filtered data if profileStatus filter is active
            if (sortField === "profileStatus") {
                GetEmployerDataWithSort("", sortField, sortOrder, currentPage);
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error(error.response.data, {
                style: {
                    padding: "18px",
                },
            });
        }
    };

    // SEARCH OPTION:

    const [search, setSearch] = useState("");
    const handleSearchInput = (e) => {
        setSearch(e.target.value);
    };

    //  const handleSearch = () =>{
    //   GetEmployerData();
    //    setSearch("");
    //  }
    const handleSearch = () => {
        // Reset sorting when searching
        setSortField(null);
        setSortOrder(null);
        setCurrentPage(1);

        if (search.trim() !== "") {
            setIsSearchMode(true);
            setCurrentSearchTerm(search.trim());
            GetEmployerData(search.trim());
            setSearch("");
        } else {
            setIsSearchMode(false);
            setCurrentSearchTerm("");
            GetEmployerData();
            setSearch("");
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    // FOR AUTHENTICATION
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        if (!localStorage.getItem("token") || !localStorage.getItem("userType") || localStorage.getItem("userType") !== "Admin") {
            navigate("/admin_login");
        }
    });
    //  END
    useEffect(() => {
        borderRemoveRef.current.scrollTop = 0;
    }, [employee._id]);

    const fetchData = async (_id) => {
        console.log("call");
        borderRemoveRef.current.scrollTop = 0;
        const response = await fetch(`/api/admin/getUserToUpdatedata/${_id}`);
        if (!response.ok) {
            throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        const userData = data.user;

        setEmployee({
            _id: userData._id,
            name: userData.name || "",
            phone: userData.phone || "",
            oldPhone: userData.phone || "",
            countryCode: userData.countryCode || "91",
            oldCountryCode: userData.countryCode || "",
            city: userData.city || "",
            organisationName: userData.organisationName || "",
            email: userData.email || "",
            role: userData.role || "Employer",
        });
    };

    const handleUserChange = (e) => {
        setEmployee({
            ...employee,
            [e.target.name]: e.target.value,
        });
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!employee.name) {
            setLoading(false);
            toast.error("Name is required!!");
        } else if (!employee.phone) {
            setLoading(false);
            toast.error("Phone is required!!");
        } else if (!employee.city) {
            setLoading(false);
            toast.error("City is required!!");
        } else if (!employee.organisationName) {
            setLoading(false);
            toast.error("Company Name is required!!");
        } else {
            console.log(employee.email, "email");
            try {
                const selectedCountryCode = String(
                    employee.oldCountryCode || employee.countryCode || ""
                )
                    .replace("+", "")
                    .trim();

                const oldPhone = String(employee.oldPhone || "").trim();
                const newPhone = String(employee.phone || "").trim();

                const isPhoneChanged = newPhone !== oldPhone;

                if (isPhoneChanged) {
                    const blockedCheck = await axios.get("/api/user/blocked-credential/check", {
                        params: {
                            phone: newPhone,
                            countryCode: selectedCountryCode,
                            ignorePhone: oldPhone,
                            ignoreCountryCode: selectedCountryCode,
                        },
                    });

                    if (blockedCheck.data.blocked) {
                        setLoading(false);
                        toast.error(
                            blockedCheck.data.message ||
                            "This phone number is already used once.",
                            {
                                style: {
                                    padding: "18px",
                                },
                            }
                        );
                        return;
                    }
                }

                const { data } = await axios.post("/api/admin/udateemployeedatafromadminsite", {
                    name: employee.name,
                    phone: newPhone,
                    city: employee.city,
                    countryCode: selectedCountryCode,
                    organisationName: employee.organisationName,
                    email: employee.email,
                });

                if (isPhoneChanged) {
                    await axios.post("/api/user/blocked-credential", {
                        oldPhone,
                        oldCountryCode: selectedCountryCode,
                        phone: newPhone,
                        countryCode: selectedCountryCode,
                        role: employee.role || "Employer",
                        reason: "Phone updated by admin",
                    });
                }

                setLoading(false);
                toast.success("Employee Updated Successfully!");

                document.querySelector(".btn-close").click();

                if (sortField === "profileStatus") {
                    GetEmployerDataWithSort("", sortField, sortOrder, currentPage);
                } else {
                    GetEmployerData();
                }

                // setEmployee(initialForm);
            } catch (error) {
                setLoading(false);
                toast.error(error.response?.data?.message || error.response?.data || "Something went wrong", {
                    style: {
                        padding: "18px",
                    },
                });
            }
        }
    };
    const [showModal, setShowModal] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);

    const handleDeleteConfirmation = (id) => {
        setIdToDelete(id);
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        await handleDeleteCandidate(idToDelete);
        setShowModal(false);
    };

    const handleCancelDelete = () => {
        setShowModal(false);
    };
    const handleDeleteCandidate = async (id) => {
        setLoading(true);
        try {
            await axios.post(`/api/admin/deleteEmployerFromAdminside/${id}`);

            const empIndex = employerData.findIndex((job) => job._id === id);

            if (empIndex !== -1) {
                const updatedEmpData = [...employerData];
                updatedEmpData.splice(empIndex, 1);
                setEmployerData(updatedEmpData);
            }
            toast.success("User Deleted Successfully");
            setLoading(false);
            await axios.post("/api/admin/logDeleteAttempt", { userId: id });
        } catch (error) {
            console.error("Error deleting job:", error);
        }
    };
    console.log(employerData, "employerData");
    return (
        <>
            <div className="my-applications">
                {loading ? (
                    <>
                        <div className="my-auto" style={{ textAlign: "center" }}>
                            <p
                                className="loaderLoader"
                                style={{
                                    color: "#4B92C8",
                                    fontWeight: "500",
                                    fontSize: "20px",
                                    marginLeft: "16px",
                                    marginBottom: "5px",
                                }}
                            >
                                Loading..
                            </p>
                            <PropagateLoader color={"#4B92C8"} loading={true} size={15} aria-label="Loading Spinner" data-testid="loader" style={{ marginLeft: "-4px" }} />
                        </div>
                    </>
                ) : (
                    <>
                        <p className="borderremove" style={{ color: "#494949", fontSize: "20px", fontWeight: "500", backgroundColor: "white", borderRadius: "10px", paddingLeft: "10%", paddingRight: "10%", paddingTop: "1%", paddingBottom: "1%", boxShadow: "0px 0px 15px 0px #00000025" }}>
                            Employer Details
                        </p>
                        <div className="AdminSearchBox" style={{
                            maxWidth: "1200px",
                            marginLeft: "auto",
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                        }}>
                            <input className="AdminSearchInput" style={{ width: "460px" }} type="text" placeholder="Search by name, email, phone" onChange={handleSearchInput} value={search} onKeyPress={handleKeyPress} />
                            <button className="AdminSearchButton" onClick={handleSearch}>
                                Search
                            </button>
                        </div>
                        <div className="table-box table-responsive border borderremove px-0">
                            <table className="applications table" style={{ marginLeft: "-2px" }}>
                                <thead className="adminTableHead">
                                    <tr>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "170px", padding: "6px 8px" }}>
                                            Employer Name
                                        </th>
                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px" }}>User Login</th>
                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>Company Name</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "companyName" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("companyName", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "companyName" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("companyName", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "170px", padding: "6px 8px" }}>
                                            Email
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", padding: "6px 8px" }}>Phone</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "120px", padding: "6px 8px" }}>Location</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "120px", padding: "6px 8px" }}>User Since</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "140px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>Profile Status</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Show Only Active Employers" style={{ fontSize: "1.3em", color: sortField === "profileStatus" && sortOrder === "asc" ? "white" : "#ddd", cursor: "pointer" }} onClick={() => handleSort("profileStatus", "asc")} />
                                                    <IoMdArrowDropdown title="Show Only Inactive Employers" style={{ fontSize: "1.3em", color: sortField === "profileStatus" && sortOrder === "desc" ? "white" : "#ddd", cursor: "pointer" }} onClick={() => handleSort("profileStatus", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "100px", padding: "6px 8px" }}>Edit Profile</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "130px", padding: "6px 8px" }}>#Delete Employer</th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>#Hourly Project Posted</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "hourlyPosted" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("hourlyPosted", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "hourlyPosted" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("hourlyPosted", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "150px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>#Fixed Project Posted</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "fixedPosted" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("fixedPosted", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "fixedPosted" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("fixedPosted", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "170px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>#Active Hourly/Fixed Posts</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "activeFixedPosted" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("activeFixedPosted", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "activeFixedPosted" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("activeFixedPosted", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "210px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>#Hourly/Fixed Projects Freelancers Hired</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "totalFreelancersHired" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("totalFreelancersHired", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "totalFreelancersHired" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("totalFreelancersHired", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                        <th style={{ textAlign: "center", verticalAlign: "middle", minWidth: "170px", cursor: "pointer", padding: "6px 8px" }}>
                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
                                                <span>#Freelancer Applied, Alltime</span>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <IoMdArrowDropup title="Sort Ascending" style={{ fontSize: "1.3em", color: sortField === "totalJobsApplied" && sortOrder === "asc" ? "white" : "#ddd" }} onClick={() => handleSort("totalJobsApplied", "asc")} />
                                                    <IoMdArrowDropdown title="Sort Descending" style={{ fontSize: "1.3em", color: sortField === "totalJobsApplied" && sortOrder === "desc" ? "white" : "#ddd" }} onClick={() => handleSort("totalJobsApplied", "desc")} />
                                                </div>
                                            </div>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading2 ? (
                                        <>
                                            <Grid item xs={12} md={12} container justifyContent="center" alignItems="center" style={{ paddingLeft: "5%" }}>
                                                <div className=" mx-auto" style={{ marginBottom: "20px", marginTop: "20px", justifyContent: "center", justifyItem: "center", textAlign: "center" }}>
                                                    <ScaleLoader color={"#4B92C8"} loading={true} size={15} aria-label="Loading Spinner" data-testid="loader" />
                                                </div>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            {employerData.length != 0 ? (
                                                <>
                                                    {employerData.map((data, index) => (
                                                        <tr key={index} className="AdminTableData">
                                                            <td
                                                                style={{
                                                                    fontSize: "14px",
                                                                    textAlign: "center",
                                                                    verticalAlign: "middle",
                                                                    cursor: "pointer",
                                                                }}
                                                                className="tableheadingstyle1"
                                                            >
                                                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                    <div
                                                                        style={{
                                                                            textAlign: "center",
                                                                            color: "#000",
                                                                            height: "45px",
                                                                            width: "45px",
                                                                            fontSize: "12px",
                                                                            border: !data?.avatar?.url && "2px solid gray",
                                                                            borderRadius: "50%",
                                                                            marginRight: "2px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            backgroundColor: !data?.avatar?.url
                                                                                ? "#e5e5e5"
                                                                                : "transparent",
                                                                            flexShrink: 0,
                                                                            overflow: "hidden",
                                                                        }}
                                                                    >
                                                                        {data?.avatar?.url ? (
                                                                            <img
                                                                                src={data?.avatar?.url}
                                                                                alt="Profile"
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "100%",
                                                                                    objectFit: "cover",
                                                                                    borderRadius: "50%",
                                                                                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                                                                                    border: "2px solid white",
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <p
                                                                                style={{
                                                                                    fontSize: "22px",
                                                                                    marginBottom: "0px",
                                                                                    color: "#000",
                                                                                    fontWeight: "500",
                                                                                    textTransform: "uppercase",
                                                                                }}
                                                                            >
                                                                                {data?.name?.slice(0, 1)}
                                                                            </p>
                                                                        )}
                                                                    </div>

                                                                    <Tooltip
                                                                        title={
                                                                            <Typography sx={{ fontSize: "15px" }}>
                                                                                {data?.name}
                                                                            </Typography>
                                                                        }
                                                                        arrow
                                                                        disableHoverListener={data?.name?.length <= 14}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                marginBottom: "0px",
                                                                                color: "#4B92C8",
                                                                                fontWeight: "500",
                                                                                textDecoration: "none",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            {data?.name &&
                                                                                (data?.name?.length > 14
                                                                                    ? data?.name?.slice(0, 14) + "..."
                                                                                    : data?.name)}
                                                                        </p>
                                                                    </Tooltip>
                                                                </div>
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }}>
                                                                <button
                                                                    onClick={() => handleLogin(data._id)}
                                                                    style={{
                                                                        backgroundColor: "#4B92C8",
                                                                        color: "#fff",
                                                                        padding: "7px 14px",
                                                                        borderRadius: "8px",
                                                                        border: "none",
                                                                        outline: "none",
                                                                        textDecoration: "none",
                                                                        fontSize: "13px",
                                                                        fontWeight: "500",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        minWidth: "70px",
                                                                        cursor: "pointer",
                                                                        transition: "all 0.25s ease",
                                                                        boxShadow: "0 2px 2px rgba(75,146,200,0.25)",
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.backgroundColor = "#357AB8";
                                                                        e.target.style.transform = "translateY(-1px)";
                                                                        e.target.style.boxShadow =
                                                                            "0 4px 12px rgba(75,146,200,0.35)";
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.backgroundColor = "#4B92C8";
                                                                        e.target.style.transform = "translateY(0px)";
                                                                        e.target.style.boxShadow =
                                                                            "0 2px 8px rgba(75,146,200,0.25)";
                                                                    }}
                                                                >
                                                                    Login
                                                                </button>
                                                            </td>
                                                            <td style={{ fontSize: "14px" }} className="tableheadingstyle6">
                                                                {data.organisationName ? data.organisationName : "Not Available"}
                                                            </td>
                                                            <td style={{ fontSize: "14px" }} className="tableheadingstyle23">
                                                                {data.email.split("@")[0]}
                                                                <span>@</span>
                                                                {data.email.split("@")[1]}
                                                            </td>
                                                            <td style={{ fontSize: "14px", minWidth: "140px" }} className="tableheadingstyle22">
                                                                {data.phone ? `${data.countryCode ? `+${data.countryCode}` : ""} ${data.phone}` : "Not Available"}
                                                            </td>
                                                            <td style={{ fontSize: "14px", minWidth: "130px" }} className="tableheadingstyle22">
                                                                {data.city ? data.city : "Not Available"}
                                                            </td>
                                                            <td style={{ fontSize: "14px", minWidth: "140px" }} className="tableheadingstyle22">
                                                                {data.dataAdded?.slice(8, 10) + " " + MONTH_DETAILS[parseInt(data.dataAdded?.slice(5, 7), 10)] + "' " + data.dataAdded?.slice(2, 4)}
                                                            </td>
                                                            <td style={{ textAlign: "center", verticalAlign: "middle", padding: "6px 8px" }}>
                                                                <div
                                                                    className="dropdown3"
                                                                    style={{
                                                                        borderRadius: "5px",
                                                                        border: "solid 1px #4B92C8",
                                                                        display: "inline-block",
                                                                        margin: "0 auto",
                                                                    }}
                                                                >
                                                                    <button className="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" onClick={() => idSelector(data._id)} style={{ fontSize: "15px", width: "100px" }}>
                                                                        {data.active == false ? "De-active" : "Active"}
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-light px-2 custom-dropdown-menu1" aria-labelledby="dropdownMenuButton2">
                                                                        {data.active == false ? (
                                                                            <li>
                                                                                <a className="dropdown-item border text-center py-2" style={{ backgroundColor: "#4B92C8", color: "white", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }} onClick={ActiveUser}>
                                                                                    Active
                                                                                </a>
                                                                            </li>
                                                                        ) : (
                                                                            <li>
                                                                                <a className="dropdown-item border text-center py-2" style={{ backgroundColor: "#4B92C8", color: "white", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }} onClick={DeActiveUser}>
                                                                                    De-active
                                                                                </a>
                                                                            </li>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                <LuClipboardEdit className="docIcon" style={{ fontSize: "21px", color: "#4B92C8" }} onClick={async () => {
                                                                    await fetchData(data._id);
                                                                    const modal = new window.bootstrap.Modal(
                                                                        document.getElementById("exampleModal")
                                                                    );
                                                                    modal.show();
                                                                }} />
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle deletehovering">
                                                                <RiDeleteBinLine className="docIcon" style={{ fontSize: "23px", color: "#646464" }} onClick={() => handleDeleteConfirmation(data._id)} />
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                {countInternshiplength(data.jobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                {countJoblength(data.jobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                {countActiveJobs(data.jobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                {countTotalHired(data.jobs)}
                                                            </td>
                                                            <td style={{ fontSize: "14px", textAlign: "center" }} className="tableheadingstyle25">
                                                                {countTotalApplied(data.jobs)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    <p style={{ padding: "15px  20px", minWidth: "200px", paddingBottom: "10", color: "red" }}>No data found!</p>
                                                </>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div
                            className="pagination"
                            style={{
                                width: "100%",
                                maxWidth: "1200px",
                                marginTop: "-40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "10px",
                                paddingInline: "3px",
                                flexWrap: "wrap",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "14px",
                                    color: "#555",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Page {currentPage} of {totalPages}
                                &nbsp;|&nbsp;
                                Showing {Math.min(currentPage * 20, totalItem)} of {totalItem} entries
                            </div>

                            <div
                                style={{
                                    textAlign: "center",
                                    flex: 1,
                                    minWidth: "250px",
                                }}
                            >
                                <PaginationWithLastButton
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    onPageChange={setCurrentPage}
                                />
                            </div>
                        </div>

                        <div className="table-box table-responsive border borderremove px-0">
                            <table className="applications table" style={{ marginBottom: "0px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Freelancers</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Employers</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Hourly Projects</th>
                                        <th style={{ padding: "2rem 2.9rem", minWidth: "170px", textAlign: "center" }}>Total Fixed Cost Projects</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalFreelancers}</div>
                                        </td>

                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalEmployers}</div>
                                        </td>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalHourlyProject}</div>
                                        </td>
                                        <td style={{ padding: "2rem 3rem 0rem 3rem" }}>
                                            <div style={{ minWidth: "170px", textAlign: "center", fontSize: "14px" }}>{totalData?.totalFixedCostProject}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
            {/* EDIT PROFILE MODEL */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content borderremove123" ref={borderRemoveRef} style={{ overflowY: "auto", borderRadius: "2px", height: "auto" }}>
                        <div className="modal-body">
                            <div style={{ textAlign: "end", paddingRight: "30px" }}>
                                <button style={{ position: "fixed" }} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            {/*EDIT APPLICATION CODE START HERE*/}
                            <div className="container">
                                <p className="text-center mx-auto" style={{ margin: "40px 0px", fontSize: "20px", fontWeight: "500", color: "#5F5F5F" }}>
                                    Edit Profile
                                </p>
                                <div className="section mx-auto" style={{ width: "90%" }}>
                                    <form className="w-100 d-flex flex-column">
                                        <div className="sub-section123">
                                            <div className="details w-100">
                                                <div className="title">Full Name</div>
                                                <input style={{ backgroundColor: "white", width: "100%", border: "1px solid #ddd" }} type="text" value={employee && employee.name} id="name" name="name" onChange={handleUserChange} onMouseOver="this.style.border='1px solid #00a5ec'" onMouseOut="this.style.border='1px solid #ddd'" />
                                            </div>

                                            <div className="details w-100">
                                                <div className="title">Email</div>
                                                <input style={{ width: "100%", border: "1px solid #ddd" }} type="email" placeholder="Email" value={employee && employee.email} name="email" onChange={handleUserChange} readOnly onMouseOver="this.style.border='1px solid #00a5ec'" onMouseOut="this.style.border='1px solid #ddd'" />
                                            </div>

                                            <div className="details w-100">
                                                <div className="title">Organization Name</div>
                                                <input style={{ backgroundColor: "white", width: "100%", border: "1px solid #ddd" }} type="text" placeholder="Company Name" value={employee && employee.organisationName} name="organisationName" id="organisationName" onChange={handleUserChange} onMouseOver="this.style.border='1px solid #00a5ec'" onMouseOut="this.style.border='1px solid #ddd'" />
                                            </div>

                                            <div className="details w-100">
                                                <div className="title">City</div>
                                                <input style={{ backgroundColor: "white", width: "100%", border: "1px solid #ddd" }} type="text" placeholder="City" value={employee && employee.city} name="city" id="city" onChange={handleUserChange} onMouseOver="this.style.border='1px solid #00a5ec'" onMouseOut="this.style.border='1px solid #ddd'" />
                                            </div>

                                            <div className="details w-100">
                                                <div className="title">Mobile Number</div>
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <input style={{ border: "1px solid #ddd" }} type="text" placeholder="" className="w-25" value={employee?.countryCode ? `+${employee.countryCode}` : ""} readOnly />
                                                    <input minLength={10} maxLength={10} style={{ backgroundColor: "white", border: "1px solid #ddd" }} type="text" className="w-50" value={employee && employee.phone} name="phone" id="phone" onChange={handleUserChange} onMouseOver="this.style.border='1px solid #00a5ec'" onMouseOut="this.style.border='1px solid #ddd'" />
                                                    <span className="w-25 d-flex align-items-center gap-1" style={{ color: "#2fb212" }}>
                                                        <MdOutlineVerifiedUser /> Verified
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" className="submit-btn123" onClick={handleUpdate}>
                                            {loading ? <Spinner /> : <span>Done</span>}
                                        </button>
                                    </form>
                                </div>
                            </div>
                            {/*EDIT APPLICATION CODE END HERE*/}
                        </div>
                    </div>
                </div>
            </div>

            <Popup open={showModal} modal closeOnDocumentClick={false}>
                <div className="overlay" style={{ background: "rgba(0, 0, 0, 0.4)" }}>
                    <div className="popup-containernew">
                        <div className="success-message mx-3" style={{ marginBottom: "10px" }}>
                            Are you sure you want to delete? This action cannot be undone.
                        </div>
                        <div style={{ display: "flex", alignItems: "center", alignSelf: "center", gap: "10px", marginBottom: "15px" }}>
                            <button className="employerbuttonbacktodash" onClick={handleCancelDelete}>
                                Cancel
                            </button>
                            <button className="employerbuttontobuyinformation" style={{ backgroundColor: "#ED5E68" }} onClick={handleConfirmDelete}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </Popup>

            <ToastContainer position="top-center" autoClose={10000} />
        </>
    );
}

export default AdminEmployers;
